// extracted by mini-css-extract-plugin
module.exports = {"actuality-card-header":"news_actuality-card-header__KpXiq","actuality-title":"news_actuality-title__3KZjE","actuality-card-body":"news_actuality-card-body__JuCDe"};